import DailyIframe from "@daily-co/daily-js";
import { makeStyles } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { BaseLayout } from "../components";
import { useQueryParams } from "../hooks";

const CALL_OPTIONS = {
  iframeStyle: {
    width: "100%",
    height: "100%",
    border: "none",
    "border-radius": "8px"
  },
  showLeaveButton: false,
  showFullscreenButton: true
};

const useStyles = makeStyles(() => ({
  ref: {
    height: "95%"
  }
}));

const MeetingPage = () => {
  const videoRef = useRef(null);
  const classes = useStyles();
  const { roomName } = useParams();
  const [{ token }] = useQueryParams();
  const [callframe, setCallframe] = useState(null);

  useEffect(() => {
    if (!videoRef || !videoRef?.current || callframe) return;

    CALL_OPTIONS.url = `https://dive-digitalvenue.daily.co/${roomName}`;
    CALL_OPTIONS.token = token;

    const newCallframe = DailyIframe.createFrame(videoRef.current, CALL_OPTIONS);

    newCallframe
      .join()
      .then(() => {
        setCallframe(newCallframe);
      })
      .catch(() => null);
  }, [callframe, roomName, token, videoRef]);

  return (
    <BaseLayout>
      <div ref={videoRef} className={classes.ref} />
    </BaseLayout>
  );
};

export default MeetingPage;
